import configAccessibilityGetters from './configGetters/configAccessibilityGetters';
import configAnniversaryGetters from './configGetters/configAnniversaryGetters';
import configAppGetters from './configGetters/configAppGetters';
import configAppLinksGetters from './configGetters/configAppLinksGetters';
import configAwsGetters from './configGetters/configAwsGetters';
import configBenefitPageGetters from './configGetters/configBenefitPageGetters';
import configConnectivityGetters from './configGetters/configConnectivityGetters';
import configConsumerServicesGetter from './configGetters/configConsumerServicesGetter';
import configContactUsGetters from './configGetters/configContactUsGetters';
import configDeviceConnectionType from './configGetters/configDeviceConnectionType';
import configDeviceDiagnosticGetters from './configGetters/configDeviceDiagnosticGetters';
import configDeviceFeaturesGetters from './configGetters/configDeviceFeaturesGetters';
import configDeviceSupportGetters from './configGetters/configDeviceSupportGetters';
import configExternalLinksGetters from './configGetters/configExternalLinksGetters';
import configFirmwareReleaseNotesGetters from './configGetters/configFirmwareReleaseNotesGetters';
import configFwGetters from './configGetters/configFwGetters';
import configGamGetters from './configGetters/configGamGetters';
import configHavGetters from './configGetters/configHavGetters';
import configHomePageGetters from './configGetters/configHomePageGetters';
import configI18nGetters from './configGetters/configI18nGetters';
import configIccGetters from './configGetters/configIccGetters';
import configLeviaGetters from './configGetters/configLeviaGetters';
import configLifestyleImagesGetter from './configGetters/configLifestyleImagesGetter';
import configLocalizationGetters from './configGetters/configLocalizationGetters';
import configLoginGetters from './configGetters/configLoginGetters';
import configLogsGetters from './configGetters/configLogsGetters';
import configLoyaltyGetters from './configGetters/configLoyaltyGetters';
import configManualActivationGetters from './configGetters/configManualActivationGetters';
import configManualRegistrationGetters from './configGetters/configManualRegistrationGetters';
import configMarketGetters from './configGetters/configMarketGetters';
import configMuleSoftGetters from './configGetters/configMuleSoftGetters';
import configPauseGuideModeGetters from './configGetters/configPauseGuideModeGetters';
import configPromoGetters from './configGetters/configPromoGetters';
import configPurchaseDateGetters from './configGetters/configPurchaseDateGetters';
import configPwaGetters from './configGetters/configPwaGetters';
import configRestrictedMarketGetters from './configGetters/configRestrictedMarketGetters';
import configScpGetters from './configGetters/configScpGetters';
import configStorageGetters from './configGetters/configStorageGetters';
import configTipsAndTricksPageGetters from './configGetters/configTipsAndTricksPageGetters';
import configTrackingGetters from './configGetters/configTrackingGetters';
import configTradeInBannerGetter from './configGetters/configTradeInBannerGetter';
import configUnmarkedGetters from './configGetters/configUnmarkedGetters';
import configUsageGetters from './configGetters/configUsageGetters';
import configWelcomePwaGetters from './configGetters/configWelcomePwaGetters';

export default {
    ...configAccessibilityGetters,
    ...configAnniversaryGetters,
    ...configAppGetters,
    ...configAppLinksGetters,
    ...configAwsGetters,
    ...configBenefitPageGetters,
    ...configConnectivityGetters,
    ...configConsumerServicesGetter,
    ...configContactUsGetters,
    ...configDeviceConnectionType,
    ...configDeviceDiagnosticGetters,
    ...configDeviceFeaturesGetters,
    ...configDeviceSupportGetters,
    ...configExternalLinksGetters,
    ...configFirmwareReleaseNotesGetters,
    ...configFwGetters,
    ...configGamGetters,
    ...configHavGetters,
    ...configHomePageGetters,
    ...configIccGetters,
    ...configLeviaGetters,
    ...configLifestyleImagesGetter,
    ...configLocalizationGetters,
    ...configLoginGetters,
    ...configLogsGetters,
    ...configLoyaltyGetters,
    ...configManualActivationGetters,
    ...configManualRegistrationGetters,
    ...configMarketGetters,
    ...configMuleSoftGetters,
    ...configPromoGetters,
    ...configPurchaseDateGetters,
    ...configRestrictedMarketGetters,
    ...configScpGetters,
    ...configStorageGetters,
    ...configTipsAndTricksPageGetters,
    ...configTrackingGetters,
    ...configTradeInBannerGetter,
    ...configUnmarkedGetters,
    ...configUsageGetters,
    ...configPauseGuideModeGetters,
    ...configI18nGetters,
    ...configWelcomePwaGetters,
    ...configPwaGetters,
};
